import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  HStack,
  Image,
  Stack,
} from "@chakra-ui/react";
import Carousel from "./Carousel";
import { cleanText, useQuery } from "../../util/helper";
import * as getSearchResultData from "../../services/Search";
import { Search } from "../../constants/constants";
import H1 from "../../Theme/Typography/H1";
import { DataNotFound } from "../../CommonComponents/DataNotFound";
import CarouselMobile from "./CarouselMobile";
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

export default function SearchResults() {
  return (
    <Stack width={"100%"}>
      <SearchResultsBody />
    </Stack>
  );
}

const SearchResultsBody = () => {
  const [allCount, setAllCount] = useState(0);
  const [masterlist,setMasterlist]=useState([])
  const [researchCentre,setResearchCentre]=useState([])

  const {bookDetails}=useParams();
  const [count, setCount] = useState(0);
  const query = useQuery();
  const [isLoading, setIsLoading] = useState(false);
  const searchsTerm = query.get("query");
  const navigate = useNavigate();
  
  const getData = async () => {
    try {
      setIsLoading(true);
      const result = await getSearchResultData.getSearchData(searchsTerm);
      setIsLoading(false);
      if (result && result.data && result.data.length > 0) {
        const primaryList = result.data.find((item) => item.index === "Primary Masterlist");
    const researchCentreData = result.data.find((item) => item.index === "Research Centre");
    setResearchCentre(researchCentreData?researchCentreData:[])
    // Setting the states
    setMasterlist(primaryList ? primaryList : []);
        // setSearchData(result.data);
        let totalHits = result.data.reduce(
          (sum, index) =>
             sum + index.count ,
          0
        );
        if (allCount > 0) {
          setCount(totalHits);
        } else {
          setCount(totalHits);
        }

        // Dynamic redirection logic for single hit results
        if (primaryList && primaryList.hits && primaryList.hits.length === 1) {
          const singleHit = primaryList.hits[0];
          // Check if route exists and doesn't contain "generic"
          if (singleHit.route && !singleHit.route.toLowerCase().includes('generic')) {
            // Redirect to route + /agraphy
            navigate(`${singleHit.route}/agraphy`, { replace: true });
            return; // Exit early to prevent rendering the search results
          }
        }
      }
    } catch (error) {
      setIsLoading(false);
      // setSearchData([]);
    }
  };
  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchsTerm]);
  const result = masterlist?.hits?.length>0 && masterlist.hits.find(hit => hit.alias === searchsTerm);
  return (
    <>
    <Stack width={"100%"} minH={"100vh"} px={{base:"10px",md:"4"}}>
      {bookDetails ? (
              <>
                <Stack alignItems={"center"} width={"100%"}>
                  {/* BookDetails component - can be implemented later if needed */}
                  <Box>Book Details</Box>
                  </Stack>
              </>
            ) : (
              <>
      {!isLoading ? (
        <>
        {/* Desktop View */}
        <Box display={{base:"none",md:"flex"}} px={{base:"0",md:"32px"}} flexDirection={"column"} width={"100%"} position={"sticky"} top={"75px"} zIndex={99}>
        <HStack bg="white" py={{base:"0",md:"15px"}}   alignItems={"flex-start"} flexDirection={"column"} gap={"10px"}>
        <H1 fontSize={"22px"} lineHeight="28.8px">
              {Search.SEARCH_RESULT_TEXT} <H1 bg='#d5edff' fontWeight="600" borderRadius="10px" pb="1" px="2" fontSize={"20px"} lineHeight="28.8px" color="black" as="span">{`"${result?.title?cleanText(result?.title):searchsTerm}" ${count}`}</H1>
            </H1>
            <H1 fontSize={"22px"} lineHeight="28.8px">
            Research Centre</H1>
          </HStack>
           </Box>
           {/* Mobile view - Masterlist hidden */}
           {/* <SearchResultsMobile masterlist={masterlist} count={count} searchsTerm={searchsTerm} secondaryMasterlist={secondaryMasterlist} result={result}/> */}

          {researchCentre && researchCentre?.count > 0 ? (
            <>
           <Box display={{base:"none",md:"block"}} width="inherit" mx="auto" paddingX={{ base: "0px", md: "32px" }}>
              <Carousel
                data={researchCentre}
                searchsTerm={searchsTerm}
                setAllCount={setAllCount}
                allCount={allCount}
              />
            </Box>
            <Box display={{base:"block",md:"none"}} maxW="100%" mx="auto" paddingX={{ base: "0px", md: "32px" }}>
              <CarouselMobile
                data={researchCentre}
                searchsTerm={searchsTerm}
                setAllCount={setAllCount}
                allCount={allCount}
              />
            </Box>
            </>
          ) : (
            <HStack>
              <DataNotFound />
            </HStack>
          )}
        </>
      ) : (
        <HStack pt="150px" justifyContent={"center"}>
          <Image src={loaderImg} width={"100px"} height={"100px"} alt="Loading" />
        </HStack>
      )}
      </>
      )}
    </Stack>
    </>
  );
};
